export const ROLES = [
    { value: 2, text: 'Utilisateur' },
    { value: 100, text: 'Administrateur' }
]

export const UserRoleEnum = Object.freeze({
    SuperAdmin: 999,
    BackofficeUser: 900,
    AppAdmin: 100,
    User: 2,
    None: 0,
});

export const GetRoleLabel = (roleValue) => {
    for (const [key, v] of Object.entries(UserRoleEnum)) {
        if (v === roleValue) {
            return key;
        }
    }
};